import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en', // fallback if key missing
    detection: {
      order: ['localStorage', 'navigator'], // check localStorage first
      caches: ['localStorage'], // save selection here
      lookupLocalStorage: 'i18nextLng', // key name in localStorage
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
